import { render, staticRenderFns } from "./OFormNoticeComp.vue?vue&type=template&id=9818a16c&"
import script from "./OFormNoticeComp.vue?vue&type=script&lang=js&"
export * from "./OFormNoticeComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports